import { DashboardSection } from '../types';

import { cacheSection } from './cache';
import { celerySection } from './celery';

export const SECTIONS: DashboardSection[] = [celerySection, cacheSection];
